import React from "react";

const TextBox = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder = "",
  rows,
  className = "",
}) => {
  return (
    <div className="flex flex-col w-full">
      {label && (
        <label htmlFor={name} className="text-gray-700 font-semibold mb-1">
          {label}
        </label>
      )}
      {rows ? (
        <textarea
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          rows={rows}
          placeholder={placeholder}
          className={`p-2 border border-gray-300 focus:border-blue-600 w-full outline-none rounded-md ${className}`}
        />
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`p-2 border border-gray-300 focus:border-blue-600 w-full outline-none rounded-md ${className}`}
        />
      )}
    </div>
  );
};

export default TextBox;
